import { PriceItem } from '@app/orders/cod-total/price-item.model';
export class OrderCalculatedPrices {
  object: string;
  PriceItems: Array<PriceItem>;
}
